import { render, staticRenderFns } from "./upcountry.vue?vue&type=template&id=0cfe7233&scoped=true"
import script from "./upcountry.vue?vue&type=script&lang=js"
export * from "./upcountry.vue?vue&type=script&lang=js"
import style0 from "./upcountry.vue?vue&type=style&index=0&id=0cfe7233&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfe7233",
  null
  
)

export default component.exports